export default class ApplicationConfiguration {
    constructor(options) {
        this.subdirectory = options.subdir
        this.initialMessages = options.initialMessages
        this._isDalkia = options.isDalkia
    }

    getSubdirectory() {
        return this.subdirectory
    }

    getInitialMessages() {
        return this.initialMessages
    }

    isDalkia() {
        return this._isDalkia
    }
}